(function () {
  // Fetch the theme-rendered HTML for recommendations (keeps Prestige look)
  async function fetchRecoSectionHTML(productId) {
    const url = `/recommendations/products?product_id=${productId}&limit=6&intent=related&section_id=cart-recommendations`;
    const res = await fetch(url, { headers: { Accept: "text/html" } });
    if (!res.ok) return "";
    return await res.text();
  }

  function getState() {
    return window.__CART_RECO__ || null;
  }

  function getTargets() {
    const container = document.getElementById("cart-dynamic-recos");
    const list = document.getElementById("cart-dynamic-recos-list");
    return { container, list };
  }

  async function mount() {
    const state = getState();
    if (!state?.anchorProductId) return;

    const { container, list } = getTargets();
    if (!container || !list) return;

    // Avoid unnecessary re-renders
    if (container.dataset.loading === "true") return;
    container.dataset.loading = "true";

    const html = await fetchRecoSectionHTML(state.anchorProductId);

    // Extract only the returned section content
    // Shopify returns HTML containing the section wrapper; we can safely inject it
    const tmp = document.createElement("div");
    tmp.innerHTML = html;

    // Grab the rendered product cards from the section output
    // If your section outputs only cards, this will be the full content
    const content = tmp.textContent && tmp.textContent.trim().length === 0 ? "" : tmp.innerHTML.trim();

    if (!content) {
      // No recommendations -> keep hidden
      container.hidden = true;
      container.removeAttribute("data-loading");
      container.dataset.loading = "false";
      return;
    }

    // Inject the HTML (Prestige cards)
    list.innerHTML = content;

    // Show block
    container.hidden = false;
    container.removeAttribute("hidden");

    container.dataset.loading = "false";
  }

  // Mount on load
  mount();

  // Cart drawers often re-render after quantity changes.
  // Observe the cart drawer and remount when it changes.
  const drawer = document.getElementById("cart-drawer");
  if (drawer) {
    let t = null;
    const obs = new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => {
        // Reset loading flag so it can re-run after rerender
        const container = document.getElementById("cart-dynamic-recos");
        if (container) container.dataset.loading = "false";
        mount();
      }, 150);
    });
    obs.observe(drawer, { childList: true, subtree: true });
  }
})();
